import { RESOLVED_THEMES, THEME_PREFERENCES } from "./theme.constants";

const THEME_PREFERENCE_VALUES = Object.values(THEME_PREFERENCES);

export const isThemePreference = (value) =>
  THEME_PREFERENCE_VALUES.includes(value);

export const getResolvedTheme = ({ isSystemDark, themePreference }) => {
  if (themePreference === THEME_PREFERENCES.DARK) return RESOLVED_THEMES.DARK;

  if (themePreference === THEME_PREFERENCES.LIGHT) return RESOLVED_THEMES.LIGHT;

  return isSystemDark ? RESOLVED_THEMES.DARK : RESOLVED_THEMES.LIGHT;
};

export const getNextThemePreference = (resolvedTheme) => {
  if (resolvedTheme === RESOLVED_THEMES.DARK) return THEME_PREFERENCES.LIGHT;

  return THEME_PREFERENCES.DARK;
};
